import { motion } from "framer-motion";

const items = [
  "SHYAM EQUIPMENT AND INFRATECH",
  "ENGINEERING EXCELLENCE",
  "EQUIPMENT RELIABILITY",
  "PAN INDIA PROJECT SUPPORT",
];

export function Marquee() {
  return (
    <div className="overflow-hidden border-y border-industrial-line bg-industrial-yellow py-4 text-industrial-black" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee gap-10 whitespace-nowrap font-mono text-sm font-semibold uppercase tracking-[0.28em]">
        {[...items, ...items, ...items, ...items].map((item, index) => (
          <motion.span key={`${item}-${index}`} className="flex items-center gap-10">
            {item} <span className="h-2 w-2 bg-industrial-black" />
          </motion.span>
        ))}
      </div>
    </div>
  );
}
